var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Suspense, useEffect, useState } from 'react';
import LoadingPlaceholder from '~/components/loading-placeholder/loading-placeholder';
const FALLBACK_DELAY_MS = 300;
// A Suspense fallback has no way to know how long its chunk has been
// loading, so the delay before showing anything lives here instead.
export function DelayedFallback({ fullPage = false }) {
    const [ready, setReady] = useState(false);
    useEffect(() => {
        const timer = window.setTimeout(() => setReady(true), FALLBACK_DELAY_MS);
        return () => window.clearTimeout(timer);
    }, []);
    return ready ? React.createElement(LoadingPlaceholder, { fullPage: fullPage }) : null;
}
// importFn is a promise returning a function whose parameters are type T
// componentParams are those parameters
export default function JITLoad(_a) {
    var { importFn, fallback = React.createElement(DelayedFallback, null) } = _a, componentParams = __rest(_a, ["importFn", "fallback"]);
    const Component = React.useMemo(() => React.lazy(importFn), [importFn]);
    return (React.createElement(Suspense, { fallback: fallback },
        React.createElement(Component, Object.assign({}, componentParams))));
}
